{
  "nameInput": {
    "placeholder": "Come ti chiami?"
  },
  "signIn": {
    "tagline": "Inizia con intenzione.",
    "signingIn": "Accesso in corso…",
    "continueApple": "Continua con Apple",
    "continueApple_aria": "Continua con Apple",
    "continueGoogle": "Continua con Google",
    "continueGoogle_aria": "Continua con Google",
    "logo_alt": "Rhemn",
    "footer": "Accedendo, accetti i nostri termini di servizio e la <privacyLink>Informativa sulla privacy</privacyLink>.",
    "divider": "oppure"
  },
  "email": {
    "identity": {
      "label": "Indirizzo email",
      "placeholder": "you@example.com",
      "change": "Modifica",
      "change_aria": "Modifica indirizzo email"
    },
    "password": {
      "label": "Password",
      "labelNew": "Scegli una password",
      "placeholder": "Password",
      "placeholderNew": "Crea una password",
      "show": "Mostra password",
      "hide": "Nascondi password"
    },
    "actions": {
      "continue": "Continua",
      "signIn": "Accedi",
      "createAccount": "Crea account",
      "forgot": "Password dimenticata?",
      "backToSignIn": "Torna all'accesso",
      "iVerified": "Ho verificato la mia email",
      "resend": "Invia di nuovo il link",
      "resendIn": "Invia di nuovo tra {{time}}",
      "signInInstead": "Accedi"
    },
    "busy": {
      "checking": "Verifica in corso…",
      "signingIn": "Accesso in corso…",
      "creating": "Creazione del tuo account…",
      "sending": "Invio…"
    },
    "switch": {
      "toCreate": "Non hai un account Rhemn? <switchBtn>Creane uno</switchBtn>",
      "toSignIn": "Hai già un account? <switchBtn>Accedi</switchBtn>"
    },
    "strength": {
      "tooShort": "Almeno 12 caratteri.",
      "level1": "Bene. Più è lunga, più è sicura.",
      "level2": "Password sicura.",
      "level3": "Password molto sicura."
    },
    "sent": {
      "title": "Controlla la tua email",
      "body": "Abbiamo inviato un link di reimpostazione a {{email}}. Scade tra un’ora.",
      "resent": "Inviato di nuovo. Controlla la tua email."
    },
    "verify": {
      "title": "Conferma la tua email",
      "body": "Abbiamo inviato un link a {{email}}. Aprilo per completare la configurazione del tuo account: proseguiremo automaticamente da lì.",
      "waiting": "In attesa che tu apra il link…",
      "resent": "Inviato di nuovo. Controlla la tua email."
    },
    "errors": {
      "invalidEmail": "Non sembra un indirizzo email.",
      "missingPassword": "Inserisci la tua password.",
      "invalidCredential": "Email o password non corretti.",
      "emailInUse": "Questa email ha già un account. <signInBtn>Accedi.</signInBtn>",
      "weakPassword": "Usa almeno 12 caratteri.",
      "passwordTooShort": "Usa almeno 12 caratteri.",
      "passwordCommon": "Questa password è troppo facile da indovinare. Prova qualcosa di meno prevedibile.",
      "emailNotVerified": "Conferma la tua email prima di continuare.",
      "providerGoogle": "Questa email è già configurata con Google. Continua con Google qui sotto.",
      "providerApple": "Questa email è già configurata con Apple. Continua con Apple qui sotto.",
      "userDisabled": "Questo account è stato disattivato.",
      "requiresRecentLogin": "Accedi di nuovo per apportare questa modifica.",
      "sessionExpired": "La tua sessione è scaduta. Accedi di nuovo.",
      "expiredActionCode": "Questo link è scaduto. Richiedine uno nuovo.",
      "invalidActionCode": "Questo link non è più valido. Richiedine uno nuovo.",
      "tooManyRequests": "Troppi tentativi. Attendi qualche minuto o reimposta la password.",
      "network": "Nessuna connessione. Controlla la rete e riprova.",
      "operationNotAllowed": "L'accesso via email non è disponibile al momento.",
      "generic": "Qualcosa è andato storto. Riprova."
    },
    "a11y": {
      "stepEmail": "Passaggio 1 di 2. Inserisci il tuo indirizzo email.",
      "stepPasswordSignIn": "Passaggio 2 di 2. Inserisci la password per accedere.",
      "stepPasswordCreate": "Passaggio 2 di 2. Scegli una password per il tuo nuovo account.",
      "stepSent": "Link di reimpostazione inviato. Controlla la tua email.",
      "stepVerify": "Account creato. Link di verifica inviato.",
      "resendReady": "Ora puoi inviare di nuovo il link."
    }
  }
}
